import React from 'react';
import ReactDOM from 'react-dom';
import './styles/reset.css';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
